import { useEffect } from "react";
import { Wrench } from "lucide-react";

export default function EmailVerification() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Email Verification — Duri Ridesharing";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-muted/30 px-4 py-16">
      <div className="w-full max-w-md rounded-2xl border border-border/80 bg-card p-8 text-center shadow-lg">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Wrench className="h-8 w-8" />
        </div>
        <h1 className="mt-6 text-2xl font-bold text-foreground">
          Email Verification
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          This feature is in progress. Please check back soon.
        </p>
      </div>
    </div>
  );
}
